import createSpinner from "../../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function ($uibModalInstance, helperService) {

    const vm = this;

    vm.customHeader = {};
    vm.cancel = cancel;
    vm.createCustomHeader = createCustomHeader;

    async function createCustomHeader() {
        vm.loading = new createSpinner();
        let headerToCreate = { HeaderName: vm.customHeader.HeaderName, HeaderValue: vm.customHeader.HeaderValue };

        try {
            await helperService.successfulSaveButton(vm.loading);
            $uibModalInstance.close(headerToCreate);
        } catch {
            vm.loading.loadingValue = false;
        }
    }

    function cancel() {
        $uibModalInstance.dismiss();
    }
}